<style scoped>
h3 {
    margin: 0em 1em 0.25em 0em;
    padding-top: 0.75em;
    font-family: Arial;
    font-weight: normal;
    font-size: 1.8em;
    line-height: 1.35em;
}

select {
    display: block;
}

button {
    margin-top: 15px;
    margin-bottom: 25px;
}

div.separator {
    margin-top: 1em;
    margin-bottom: 2em;
    padding: 0;
    border-bottom: 1px dotted #000;
    font-size: 0.5em;
    line-height: 25%;
}
</style>

<template lang="html">
    <div>
        <h3>Vendor Upload</h3>

        <div v-if="!vendor">
            <a v-on:click="initiate" href="javascript:;" style="color: #375; text-decoration: underline;">Enable vendor pathway</a>
        </div>

        <div v-else="vendor">
            <a v-on:click="initiate" href="javascript:;" style="color: #375; text-decoration: underline;">Enable vendor pathway</a>

            <div>
                <p>
                    <b>Zip file:</b>
                    <a v-bind:href="'/api/vendors/' + articleId + '/zip'"
                        >{{ articleId }}.zip</a
                    >
                </p>

                <div class="form-group">
                    <label>Status: </label>
                    <span
                        v-if="vendor.uploaded_at"
                        class="badge badge-success"
                        style="font-size: 14px;"
                        >Sent to vendor</span
                    >
                    <span v-else class="badge badge-danger" style="font-size: 14px;"
                        >Not yet sent to vendor.</span
                    >
                </div>

                <div class="form-group">
                    <label>Uploaded At: </label>
                    <span
                        v-if="vendor.uploaded_at"
                        class="badge badge-secondary"
                        style="font-size: 14px;"
                        >{{ vendor.uploaded_at }}</span
                    >
                    <span v-else>--/--</span>
                </div>

                <div class="form-group">
                    <label>Vendor</label>
                    <p>
                        Transforma
                    </p>
                </div>

                <div class="form-group">
                    <label>Document</label>

                    <select v-model="vendor.data.document" style="width: 45%;">
                        <option value="">Please select a document</option>
                        <option
                            v-for="document in documents"
                            v-bind:value="{
                                id: document.file_id,
                                revision: document.revision,
                            }"
                            >{{ document.original_file_name }}</option
                        >
                    </select>
                </div>

                <div class="form-group">
                    <label>Copyediting Level</label>

                    <select v-model="vendor.data.level" style="width: 15%;">
                        <option value="">Please select a copyediting level</option>
                        <option value="0">0 (no copyedit)</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Notes</label>
                    <textarea
                        name="name"
                        rows="16"
                        cols="80"
                        v-model="vendor.data.notes"
                    ></textarea>
                </div>

                <div class="form-group float-right">
                    <button
                        v-on:click="save"
                        v-bind:class="{ deactive: vendor.uploaded_at }"
                    >
                        Save Configuration
                    </button>
                    <button
                        v-on:click="send"
                        v-bind:class="{ deactive: vendor.uploaded_at }"
                    >
                        Send to Vendor
                    </button>
                </div>
            </div>
        
            <br />
            <br />
            <br />

            <div v-for="(result, resultIndex) in vendor.results">
                <div class="form-group">
                    <label
                        >Response from Transforma #{{ resultIndex + 1 }}:
                        <small
                            >(<a
                                v-bind:href="
                                    'https://' +
                                        result.bucket +
                                        '.s3.us-east-2.amazonaws.com/' +
                                        result.key
                                "
                                target="_blank"
                                >view package</a
                            >)</small
                        ></label
                    >

                    <div v-if="result.status == 'received'">
                        <label>Notes (optional)</label>
                        <input type="file" v-on:change="handleUpload" />
                        <textarea v-model="note"></textarea>

                        <button v-on:click="action('rejected', result)">
                            Reject
                        </button>
                        <button v-on:click="action('accepted', result)">
                            Accept and Sync
                        </button>
                    </div>

                    <div v-if="result.status == 'rejected'">
                        This package was rejected.

                        <p v-if="result.notes">
                            <q>{{ result.notes }}</q>
                        </p>
                    </div>
                    <div v-if="result.status == 'accepted'">
                        This package was accepted.

                        <p v-if="result.notes">
                            <q>{{ result.notes }}</q>
                        </p>
                    </div>
                    <div v-if="result.status == 'revised'">
                        (revision) This package contained an updated version of
                        the PDF after a minor XML modification was sent.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["articleId"],
    data: {
        vendors: [
            {
                id: 1,
                name: "Transforma",
            },
        ],
        file: null,
        note: null,
        documents: [],

        vendor: null,
    },
    methods: {
        getVendor: async function() {
            let response = await axios.get(
                "/api/articles/" + this.articleId + "/vendor"
            )

            this.vendor = response.data

            this.$forceUpdate()
        },
        getFiles: async function() {
            let response = await axios.get(
                "/api/vendors/" + this.articleId + "/files"
            )

            this.documents = response.data

            this.$forceUpdate()
        },
        getVendors: async function() {
            let response = await axios.get("/api/vendors")

            this.vendors = response.data

            this.$forceUpdate()
        },
        action: async function(status, result) {
            let formData = new FormData()
            
            if (this.file) {
                formData.append("file", this.file)
            }
            
            formData.append("note", this.note)
            formData.append("status", status)

            let response = await axios.post(
                "/api/vendors/" + this.articleId + "/results/" + result.id,
                formData
            )

            this.getVendor()
        },
        handleUpload: function(event) {
            this.file = event.target.files[0]
        },
        initiate: async function() {
            let vm = this

            let response = await axios.post("/api/vendors/" + this.articleId)

            if (response) {
                window.location.reload();
            }
        },
        uninitiate: async function() {
            
        },
        save: async function() {
            let response = await axios.put(
                "/api/vendors/" + this.articleId,
                this.vendor.data
            )
        },
        send: async function() {
            let response = await axios.post(
                "/api/vendors/" + this.articleId + "/send-package"
            )
        },
    },
    created() {
        this.getVendor()
        this.getVendors()
        this.getFiles()
    },
    updated() {
        updateIFrameHeight()
    },
}
</script>
